import { apiGet } from '../../api'

export const get_catch_up_days = () => {
  return apiGet({
    endpoint: `events/catch_up_days`
  })
}
